<template>
  <section class="r-daily-bonus-configs">
    <ac-data-table
      :headers="headers"
      :items.sync="items"
      :item-class="row_class"
      item-key="uid"
      hide-default-footer
      disable-pagination
      fixed-header
      :height="winsize.height - 220"

      :search.sync="search"
      :show-bulk="false"

      title="Configs"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Config
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-daily-bonus-config-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </section>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {DailyBonusConfig} from "@/modules/redactor/models/daily-bonus/DailyBonusConfig";

import RDailyBonusConfigDialog from "@/modules/redactor/views/daily-bonus/r-daily-bonus-config-dialog.vue";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";

export default {
  name: "r-daily-bonus-configs",
  components: {RDialogPreviewCollection, AcDataTable, RDailyBonusConfigDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Name", value: "name"},
      {text: "Key", value: "key"},
      {text: "Status", value: "enabled"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(DailyBonusConfig)
    }
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(item) {
      this.$refs["dialog"].show(ViewRules.COPY, item.copy()).then(
          result => {
            RedactorUtils.pushDailyBonusConfig(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_create() {
      this.$refs["dialog"].show(ViewRules.CREATE, null).then(
          result => {
            RedactorUtils.pushDailyBonusConfig(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(item) {
      this.$refs["dialog"].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushDailyBonusConfig(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeDailyBonusConfig(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },
    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushDailyBonusConfig(result);
    },

    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, DailyBonusConfig, "daily-bonus-config")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getDailyBonusConfigs();
  }
}
</script>